"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSpring = require("react-spring");

var _renderprops = require("react-spring/renderprops.cjs");

var _conductor = require("@virtuous/conductor");

var _context = require("../../../context");

var _constants = require("../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var immediate = true;

var SpringRoute =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SpringRoute, _React$Component);

  function SpringRoute() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SpringRoute);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SpringRoute)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      render: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleStart", function () {
      var current = _this.props.current;
      var eventName = current ? _constants.EVENT_WILL_ENTER : _constants.EVENT_WILL_LEAVE;
      immediate = false;

      _conductor.emitter.emit(eventName, _this.context);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRest", function () {
      var current = _this.props.current;

      if (current) {
        _this.emitDidEnter();
      } else {
        _this.setState({
          render: false
        }, _this.emitDidLeave);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "emitDidEnter", function () {
      _conductor.emitter.emit(_constants.EVENT_DID_ENTER, _this.context);
    });

    _defineProperty(_assertThisInitialized(_this), "emitDidLeave", function () {
      _conductor.emitter.emit(_constants.EVENT_DID_LEAVE, _this.context);
    });

    return _this;
  }

  _createClass(SpringRoute, [{
    key: "render",

    /**
     * @returns {JSX|null}
     */
    value: function render() {
      var render = this.state.render;

      if (!render) {
        return null;
      }

      var _this$props = this.props,
          className = _this$props.className,
          Component = _this$props.component,
          current = _this$props.current,
          index = _this$props.index,
          nextRoute = _this$props.nextRoute,
          prevRoute = _this$props.prevRoute,
          spring = _this$props.spring;

      var prev = _conductor.stack.get(prevRoute);

      var next = _conductor.stack.get(nextRoute);

      var params = {
        action: _conductor.router.action,
        current: current,
        index: index,
        prev: prev,
        next: next
      };
      return _react["default"].createElement(_renderprops.Spring, _extends({
        immediate: immediate
      }, spring(params), {
        "native": false,
        onStart: this.handleStart,
        onRest: this.handleRest
      }), function (props) {
        return _react["default"].createElement(_reactSpring.animated.div, {
          className: className,
          style: _objectSpread({}, props, {
            zIndex: index
          })
        }, _react["default"].createElement(Component, {
          route: current ? next : prev
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",

    /**
     * When the route is the current route then make sure that it renders.
     * @param {Object} props The new component props.
     * @returns {Object|null}
     */
    value: function getDerivedStateFromProps(props) {
      if (props.current) {
        return {
          render: true
        };
      }

      return null;
    }
    /**
     * When the animation begins then remove immediate override and emit event.
     */

  }]);

  return SpringRoute;
}(_react["default"].Component);

_defineProperty(SpringRoute, "contextType", _context.RouteContext);

_defineProperty(SpringRoute, "defaultProps", {
  className: null
});

var _default = SpringRoute;
exports["default"] = _default;